export default __webpack_public_path__ + "static/fingernails-8eaf1e7153ef27245cabfeb95fb96f36.png";